'use client';

import React from 'react';
import { Button } from '@/components/ui/button';
import useModal from '@/hooks/useModal';
import ModalConfirmationAlert from '@/components/sections/modal-confirmation-alert';

interface ModalResetProps {
  title: string;
  onAction?: () => void;
}

const ModalReset = ({ title, onAction }: ModalResetProps) => {
  const modalReset = useModal();

  return (
    <>
      <div className='mb-3 grid grid-cols-2 items-center gap-2'>
        <label>{title}</label>
        <Button
          variant='link'
          size='sm'
          className='ml-auto text-xs text-red-500'
          onClick={() => modalReset.open()}
        >
          restore to default
        </Button>
      </div>
      <ModalConfirmationAlert
        openModal={modalReset.isShow}
        onConfirm={() => {
          onAction?.();
          modalReset.close();
        }}
        setOpenModal={modalReset.setIsShow}
        isLoadingConfirm={false}
        type='warning'
        title='Reset Section'
        description='Are you sure you want to reset this section? This action cannot be undone.'
      />
    </>
  );
};

export default ModalReset;
